import { twMerge } from 'tailwind-merge';
import { KeyValue } from './types';
import cx from 'classnames';

interface IAvatarProps {
  person: any;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  children?: React.ReactNode;
  className?: string;
}

const sizes: KeyValue = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16',
};

export default function Avatar({ person, size = 'md', children, className }: IAvatarProps) {
  const firstName = person?.firstName;
  const lastName = person?.lastName;
  const initials = `${firstName?.[0]}${lastName?.[0]}`;
  const profileImage = person?.profileImage;

  return (
    <div className="relative">
      <div
        className={twMerge(
          'uppercase bg-neutral-300 rounded-full w-10 h-10 text-white flex justify-center overflow-hidden  items-center',
          sizes[size as string] as string,
          className
        )}
      >
        {profileImage ? <img src={profileImage} alt={initials} /> : initials}
      </div>
      {children}
    </div>
  );
}
